import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const REPORT_ROLLUP_QUERY_KEY = "reportRollup";

/** Refetches where the organization's reporting facts stand after a rebuild is asked for. */
export const useInvalidateReportRollup = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [REPORT_ROLLUP_QUERY_KEY]
    });
  }, [queryClient]);
};
